import { AppState } from 'store/rootReducer';

const makeSelectQuery = (queryKey: string) => (reduxState: AppState) =>
  reduxState?.query[queryKey] || {
    data: undefined,
    timestamp: '',
    status: 'idle',
  };

export { makeSelectQuery };
